module.exports = __webpack_public_path__ + "media/images/app/become-vendor/hero-thumbnail-99dd95d4f458efb4b6aeda4614f0c696.webp";